(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atmospheres"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-atmospheres]').forEach((root) => {
      const tabs = root.querySelectorAll('[data-atmo-tab]');
      const panels = root.querySelectorAll('[data-atmo-panel]');
      const activate = (id) => {
        tabs.forEach((t) => { const on = t.dataset.atmoTab === id; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
        panels.forEach((p) => { const on = p.dataset.atmoPanel === id; p.classList.toggle('is-active', on); p.hidden = !on; });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab.dataset.atmoTab));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
          tabs[next].focus();
          activate(tabs[next].dataset.atmoTab);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ba]').forEach((root) => {
      const range = root.querySelector('[data-ba-range]');
      const handle = root.querySelector('[data-ba-handle]');
      const set = (val) => {
        root.style.setProperty('--start', val + '%');
        handle.style.left = val + '%';
      };
      range.addEventListener('input', () => set(range.value));
      set(range.value);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ORDER = ['day', 'afternoon', 'night'];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-hero]').forEach((hero) => {
      const setState = (state) => {
        hero.dataset.state = state;
        hero.querySelectorAll('[data-hero-layer]').forEach((l) => l.classList.toggle('is-active', l.dataset.heroLayer === state));
        hero.querySelectorAll('[data-hero-state]').forEach((b) => {
          const active = b.dataset.heroState === state;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active);
        });
      };

      const hour = new Date().getHours();
      let current = 'day';
      if (hour >= 17 || hour < 6) current = 'night';
      else if (hour >= 12) current = 'afternoon';
      setState(current);

      const delay = parseInt(hero.dataset.heroAutoplay, 10);
      if (!delay) {
        hero.querySelectorAll('[data-hero-state]').forEach((btn) => btn.addEventListener('click', () => setState(btn.dataset.heroState)));
        return;
      }

      let timer = null;
      let visible = true;

      const stop = () => { clearTimeout(timer); timer = null; };
      const play = (wait) => {
        stop();
        if (!visible || document.hidden || reduced.matches) return;
        timer = setTimeout(() => {
          current = ORDER[(ORDER.indexOf(current) + 1) % ORDER.length];
          setState(current);
          play(delay);
        }, wait == null ? delay : wait);
      };

      hero.querySelectorAll('[data-hero-state]').forEach((btn) => {
        btn.addEventListener('click', () => {
          current = btn.dataset.heroState;
          setState(current);
          play(delay * 3); // dá um tempo maior antes de retomar o ciclo
        });
      });

      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
      reduced.addEventListener('change', () => (reduced.matches ? stop() : play()));

      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          visible = entries[0].isIntersecting;
          visible ? play() : stop();
        }, { threshold: 0.15 }).observe(hero);
      } else {
        play();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colors-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-colorshop]').forEach((root) => {
      const tabs = root.querySelectorAll('[data-color-tab]');
      const panels = root.querySelectorAll('[data-color-panel]');
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
        panels.forEach((p) => { const on = p.dataset.colorPanel === tab.dataset.colorTab; p.classList.toggle('is-active', on); p.hidden = !on; });
      }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.featured').forEach((section) => {
      const track = section.querySelector('[data-carousel-track]');
      const prev = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');
      if (!track) return;
      const step = () => track.querySelector('.featured__item')?.offsetWidth + 24 || 300;
      const update = () => {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') track.scrollBy({ left: step(), behavior: 'smooth' });
        if (e.key === 'ArrowLeft') track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const wrap = document.querySelector('[data-header]');
    if (wrap && wrap.classList.contains('header-wrap--sticky') || (wrap && wrap.classList.contains('header-wrap--transparent'))) {
      const onScroll = () => wrap.classList.toggle('is-scrolled', window.scrollY > 40);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // publica a altura real do cabeçalho para as seções que ficam por baixo dele
    if (wrap) {
      const root = document.documentElement;
      root.classList.toggle('header-transparent', wrap.classList.contains('header-wrap--transparent'));
      const measure = () => root.style.setProperty('--header-height', wrap.offsetHeight + 'px');
      measure();
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(wrap);
      else window.addEventListener('resize', measure, { passive: true });
    }

    const form = document.querySelector('[data-predictive-search]');
    if (!form) return;
    const input = form.querySelector('[data-predictive-input]');
    const results = document.querySelector('[data-predictive-results]');
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const url = window.shopUrls.predictiveSearch + '?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection,page,article&section_id=predictive-search';
          const res = await fetch(url);
          results.innerHTML = await res.text();
        } catch (e) { results.innerHTML = ''; }
      }, 220);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    const country = document.querySelector('[data-address-country]');
    const province = document.querySelector('[data-address-province]');
    if (!country || !province) return;
    function sync() {
      const opt = country.options[country.selectedIndex];
      const provinces = opt ? JSON.parse(opt.getAttribute('data-provinces') || '[]') : [];
      province.innerHTML = '';
      province.disabled = provinces.length === 0;
      provinces.forEach((p) => { const o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; province.appendChild(o); });
    }
    country.addEventListener('change', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    function init() {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;
    const API = window.LumeoCartAPI;
    if (!API) return;
    async function mutate(payload) {
      let cart;
      try {
        cart = await API.changeLine(payload);
      } catch (err) {
        console.error('[Lumeo] cart page update failed', payload, err);
        return;
      }
      const sub = page.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = API.money(cart.total_price);
      page.querySelectorAll('[data-cart-item]').forEach((row) => {
        const line = cart.items.find((i) => i.key === row.dataset.key);
        if (!line) { row.remove(); return; }
        const p = row.querySelector('[data-line-price]');
        if (p) p.textContent = API.money(line.final_line_price);
        const inp = row.querySelector('[data-qty-line]');
        if (inp && document.activeElement !== inp) inp.value = line.quantity;
      });
      if (cart.item_count === 0) window.location.reload();
    }
    page.addEventListener('click', (e) => {
      const row = e.target.closest('[data-cart-item]'); if (!row) return;
      const inp = row.querySelector('[data-qty-line]');
      if (e.target.closest('[data-cart-remove]')) { mutate({ id: row.dataset.key, quantity: 0 }); return; }
      const step = e.target.closest('[data-qty-line-step]');
      if (step) mutate({ id: row.dataset.key, quantity: Math.max(0, (Number(inp.value) || 1) + Number(step.dataset.qtyLineStep)) });
    });
    page.addEventListener('change', (e) => {
      const inp = e.target.closest('[data-qty-line]'); if (!inp) return;
      const row = inp.closest('[data-cart-item]');
      mutate({ id: row.dataset.key, quantity: Math.max(0, Number(inp.value) || 0) });
    });
    }

    if (window.LumeoCartAPI || document.readyState === 'complete') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    const sort = document.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
    const filters = document.querySelector('[data-filters]');
    const toggle = document.querySelector('[data-filter-toggle]');
    if (toggle && filters) toggle.addEventListener('click', () => filters.classList.toggle('is-open'));
    if (filters) {
      let t;
      filters.addEventListener('change', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const form = filters.querySelector('form');
          const params = new URLSearchParams(new FormData(form));
          const url = new URL(window.location);
          const sortVal = url.searchParams.get('sort_by');
          if (sortVal) params.set('sort_by', sortVal);
          window.location.href = window.location.pathname + '?' + params.toString();
        }, 400);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    const login = document.querySelector('[data-login-pane]');
    const recover = document.querySelector('[data-recover-pane]');
    if (!login || !recover) return;
    document.querySelectorAll('[data-show-recover]').forEach((b) => b.addEventListener('click', () => { login.hidden = true; recover.hidden = false; }));
    document.querySelectorAll('[data-show-login]').forEach((b) => b.addEventListener('click', () => { login.hidden = false; recover.hidden = true; }));
    if (window.location.hash === '#recover') { login.hidden = true; recover.hidden = false; }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const dataEl = root.querySelector('[data-product-variants]');
      let variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      const money = (cents) => {
        if (window.LumeoCartAPI) return window.LumeoCartAPI.money(cents);
        try {
          return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' });
        } catch (e) {
          return 'R$ ' + (cents / 100).toFixed(2);
        }
      };

      const showMedia = (id) => {
        root.querySelectorAll('[data-media-id]').forEach((s) => s.classList.toggle('is-active', String(s.dataset.mediaId) === String(id)));
        root.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)));
      };
      root.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)));

      function currentSelection() {
        const groups = {};
        root.querySelectorAll('[data-product-option]:checked').forEach((el) => { groups[el.dataset.optIndex] = el.value; });
        return Object.keys(groups).sort((a, b) => a - b).map((k) => groups[k]);
      }
      function apply() {
        root.querySelectorAll('.variant-option label').forEach((l) => {
          const inp = l.querySelector('input'); if (inp) l.classList.toggle('is-selected', inp.checked);
        });
        root.querySelectorAll('[data-selected-label]').forEach((el) => {
          const picked = root.querySelector('[data-opt-index="' + el.dataset.selectedLabel + '"]:checked');
          el.textContent = picked ? picked.value : '';
        });
        const opts = currentSelection();
        if (!opts.length) return;
        const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
        const form = root.querySelector('[data-product-form]');
        const priceEl = root.querySelector('[data-price-target]');
        const addBtn = root.querySelector('[data-add-btn]');
        const skuEl = root.querySelector('[data-sku-target]');
        if (!variant) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; } return; }
        if (form) form.querySelector('[name="id"]').value = variant.id;
        if (priceEl) priceEl.innerHTML = variant.compare_at_price > variant.price
          ? '<span class="price--sale">' + money(variant.price) + '</span> <s class="price--compare">' + money(variant.compare_at_price) + '</s>'
          : '<span class="price--regular">' + money(variant.price) + '</span>';
        if (skuEl) skuEl.textContent = variant.sku ? ('SKU: ' + variant.sku) : '';
        if (variant.featured_media) showMedia(variant.featured_media.id);
        if (addBtn) { addBtn.disabled = !variant.available; addBtn.textContent = variant.available ? addBtn.dataset.available : addBtn.dataset.soldout; }
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      root.addEventListener('change', (e) => { if (e.target.matches('[data-product-option]')) apply(); });

      root.querySelectorAll('[data-share]').forEach((btn) => btn.addEventListener('click', async () => {
        const url = btn.dataset.share;
        if (navigator.share) { try { await navigator.share({ url }); } catch (e) {} }
        else { try { await navigator.clipboard.writeText(url); btn.classList.add('is-copied'); } catch (e) {} }
      }));
      apply();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monte-a-sua"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Demo dataset — used only if the section has zero option blocks.
    const DEMO = [
      { group: 'Base', values: [
        { label: 'Madeira clara', price: 0,    swatch: '#c9a06a', role: 'base', fill: '#c9a06a' },
        { label: 'Nogueira',      price: 4000, swatch: '#5f4326', role: 'base', fill: '#5f4326' },
        { label: 'Preto fosco',   price: 6000, swatch: '#2b2b2b', role: 'base', fill: '#2b2b2b' },
        { label: 'Mármore',       price: 9000, swatch: '#e8e6e1', role: 'base', fill: '#e8e6e1' },
      ]},
      { group: 'Cúpula', values: [
        { label: 'Cônica',     price: 0,    role: 'shape', shape: 'cone' },
        { label: 'Cilíndrica', price: 3000, role: 'shape', shape: 'cyl' },
        { label: 'Redonda',    price: 5000, role: 'shape', shape: 'dome' },
      ]},
      { group: 'Cor / acabamento', values: [
        { label: 'Linho',       price: 0,    swatch: '#efe4d0', role: 'shade', fill: '#efe4d0' },
        { label: 'Terracota',   price: 2000, swatch: '#c96f4a', role: 'shade', fill: '#d98063' },
        { label: 'Verde sálvia',price: 2000, swatch: '#8a9a7b', role: 'shade', fill: '#9caf8c' },
        { label: 'Grafite',     price: 2500, swatch: '#3a3a3a', role: 'shade', fill: '#4a4a4a' },
      ]},
      { group: 'Lâmpada', values: [
        { label: 'Quente 2700K', price: 0,    swatch: '#ffb85c', role: 'glow', fill: '#ffd89b' },
        { label: 'Neutra 4000K', price: 1500, swatch: '#fff2d6', role: 'glow', fill: '#fff0cf' },
        { label: 'Fria 6000K',   price: 1500, swatch: '#cfe4ff', role: 'glow', fill: '#dbecff' },
      ]},
    ];

    const SHADE_PATHS = {
      cone: 'M120 176 L280 176 L250 70 L150 70 Z',
      cyl:  'M132 176 L268 176 L268 78 L132 78 Z',
      dome: 'M120 176 L280 176 C280 96 120 96 120 176 Z',
    };
    const slug = (s) => (s || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

    document.querySelectorAll('[data-lb]').forEach((root) => {
      let cfg = { options: [], hasBlocks: false };
      try { cfg = JSON.parse(root.querySelector('[data-lb-config]').textContent); } catch (e) {}

      const basePrice = parseInt(root.dataset.basePrice || '0', 10);
      const variantId = root.dataset.variantId ? parseInt(root.dataset.variantId, 10) : null;
      const money = (c) => {
        if (window.LumeoCartAPI) return window.LumeoCartAPI.money(c);
        try {
          return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' });
        } catch (e) {
          return 'R$ ' + (c / 100).toFixed(2);
        }
      };
      const sid = root.dataset.sectionId || Math.random().toString(36).slice(2, 6);

      const groupsEl = root.querySelector('[data-lb-groups]');
      const priceEl = root.querySelector('[data-lb-price]');
      const linesEl = root.querySelector('[data-lb-lines]');
      const errorEl = root.querySelector('[data-lb-error]');
      const addBtn = root.querySelector('[data-lb-add]');
      const stage = root.querySelector('[data-lb-stage]');
      const layersWrap = root.querySelector('[data-lb-layers]');

      // SVG refs
      const baseEl = root.querySelector('[data-lb-base]');
      const poleEl = root.querySelector('[data-lb-pole]');
      const shadeEl = root.querySelector('[data-lb-shade]');
      const glowStop = root.querySelector('[data-lb-bulb-stop]');
      const bulbEl = root.querySelector('[data-lb-bulb]');

      // Build grouped model from blocks (preserving order) or fall back to DEMO.
      let model;
      if (cfg.hasBlocks && cfg.options.length) {
        const byGroup = {}, order = [];
        cfg.options.forEach((o) => {
          if (!byGroup[o.group]) { byGroup[o.group] = { group: o.group, values: [] }; order.push(o.group); }
          byGroup[o.group].values.push(o);
        });
        model = order.map((g) => byGroup[g]);
      } else {
        model = DEMO;
        if (layersWrap) layersWrap.remove();
      }

      // Every option carries a PNG layer? -> use image mode instead of SVG.
      const layerImgs = root.querySelectorAll('[data-lb-layer]');
      const useImages = cfg.hasBlocks && layerImgs.length > 0 &&
        model.every((g) => g.values.every((v) => v.hasImage));
      if (useImages) { const svg = root.querySelector('[data-lb-svg]'); svg && svg.remove(); }
      else if (layersWrap && cfg.hasBlocks) { layersWrap.remove(); }

      // Render controls
      const state = {}; // group -> selected value
      model.forEach((grp, gi) => {
        const fs = document.createElement('fieldset');
        fs.className = 'lb__group';
        fs.innerHTML = '<div class="lb__group-head"><legend class="lb__group-name">' + grp.group +
          '</legend><span class="lb__group-step">Passo ' + (gi + 1) + '</span></div>';
        const vals = document.createElement('div');
        vals.className = 'lb__values';
        grp.values.forEach((v, vi) => {
          const label = document.createElement('label');
          label.className = 'lb__value' + (vi === 0 ? ' is-selected' : '');
          const sw = (v.swatch || v.fill) ? '<span class="lb__swatch" style="background:' + (v.swatch || v.fill) + '"></span>' : '';
          const delta = v.price ? '<span class="lb__delta">+' + money(v.price) + '</span>' : '';
          label.innerHTML =
            '<input type="radio" name="lb-' + sid + '-' + gi + '" ' + (vi === 0 ? 'checked' : '') + '>' +
            '<span class="lb__chip">' + sw + '<span>' + v.label + '</span>' + delta + '</span>';
          label.querySelector('input').addEventListener('change', () => {
            vals.querySelectorAll('.lb__value').forEach((l) => l.classList.remove('is-selected'));
            label.classList.add('is-selected');
            state[grp.group] = v;
            render();
          });
          vals.appendChild(label);
          if (vi === 0) state[grp.group] = v;
        });
        fs.appendChild(vals);
        groupsEl.appendChild(fs);
      });

      function shadeTint(hex) {
        try {
          const n = parseInt(hex.slice(1), 16);
          const r = Math.min(255, (n >> 16 & 255) + 30), g = Math.min(255, (n >> 8 & 255) + 24), b = Math.min(255, (n & 255) + 18);
          return 'rgb(' + r + ',' + g + ',' + b + ')';
        } catch (e) { return hex; }
      }

      function applyVisual() {
        if (useImages) {
          layerImgs.forEach((img) => {
            const grp = model.find((m) => slug(m.group) === img.dataset.group);
            const sel = grp && state[grp.group];
            img.hidden = !(sel && sel.label === img.dataset.value);
          });
          return;
        }
        model.forEach((grp) => {
          const sel = state[grp.group];
          if (!sel || !sel.role) return;
          const color = sel.fill || sel.swatch;
          switch (sel.role) {
            case 'base':
              if (color && baseEl) { baseEl.style.fill = color; poleEl.style.fill = shadeTint(color); }
              break;
            case 'shape':
              if (sel.shape && SHADE_PATHS[sel.shape] && shadeEl) shadeEl.setAttribute('d', SHADE_PATHS[sel.shape]);
              break;
            case 'shade':
              if (color && shadeEl) shadeEl.style.fill = color;
              break;
            case 'glow':
              if (color) { glowStop && glowStop.setAttribute('stop-color', color); bulbEl && (bulbEl.style.fill = color); }
              break;
          }
        });
      }

      function render() {
        let total = basePrice;
        const lines = [];
        model.forEach((grp) => {
          const sel = state[grp.group];
          if (!sel) return;
          total += sel.price || 0;
          lines.push('<div class="lb__line"><span>' + grp.group + ': ' + sel.label + '</span><span>' +
            (sel.price ? '+' + money(sel.price) : '—') + '</span></div>');
        });
        priceEl.textContent = money(total);
        linesEl.innerHTML = lines.join('');
        applyVisual();
      }

      // Light toggle
      const lightBtn = root.querySelector('[data-lb-lighttoggle]');
      lightBtn && lightBtn.addEventListener('click', () => {
        const off = stage.classList.toggle('lb__stage--off');
        lightBtn.setAttribute('aria-pressed', String(!off));
      });

      // Surprise me
      const randomBtn = root.querySelector('[data-lb-random]');
      randomBtn && randomBtn.addEventListener('click', () => {
        groupsEl.querySelectorAll('fieldset').forEach((fs) => {
          const inputs = fs.querySelectorAll('input');
          const pick = inputs[Math.floor(Math.random() * inputs.length)];
          pick.checked = true;
          pick.dispatchEvent(new Event('change'));
        });
        stage.classList.remove('lb__stage--off');
        lightBtn && lightBtn.setAttribute('aria-pressed', 'true');
      });

      // Add to cart
      root.querySelector('[data-lb-form]').addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.textContent = '';
        if (!variantId) {
          errorEl.textContent = 'Defina um produto-base na seção (personalização do tema) para habilitar o carrinho.';
          return;
        }
        const properties = {};
        model.forEach((grp) => { if (state[grp.group]) properties[grp.group] = state[grp.group].label; });
        addBtn.disabled = true;
        const original = addBtn.textContent;
        addBtn.textContent = 'Adicionando…';
        try {
          await window.LumeoCartAPI.addToCart({ id: variantId, quantity: 1, properties });
          addBtn.textContent = 'Adicionado ✓';
          setTimeout(() => { addBtn.textContent = original; addBtn.disabled = false; }, 1600);
        } catch (err) {
          errorEl.textContent = (err && err.description) || 'Não foi possível adicionar ao carrinho.';
          addBtn.textContent = original; addBtn.disabled = false;
        }
      });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
